/**
 * Merges the base theme with the accent (sidenav) color from settings.
 * Use this so borders, buttons (primary), and inputs follow the theme color.
 */

import { createTheme } from "@mui/material/styles";

const SIDENAV_COLORS = ["primary", "dark", "info", "success", "warning", "error"];

export default function getThemeWithAccent(baseTheme, sidenavColor = "info") {
  const colorKey = SIDENAV_COLORS.includes(sidenavColor) ? sidenavColor : "info";
  const basePalette = baseTheme.palette[colorKey] || baseTheme.palette.primary;
  // Sidenav active item uses palette.gradients[colorKey] (e.g. info → #0061FE).
  // Stock theme also set palette.info.main to a different hue (#06b6d4), so buttons looked teal.
  // Use the gradient as the single source of truth so page controls match the navbar.
  const g =
    baseTheme.palette.gradients?.[colorKey] ||
    baseTheme.palette.gradients?.info ||
    baseTheme.palette.gradients?.primary;
  const accent = {
    ...basePalette,
    main: g?.main ?? basePalette.main,
    focus: g?.state ?? basePalette.focus ?? g?.main ?? basePalette.main,
  };
  const accentGradient = {
    main: accent.main,
    state: accent.focus !== accent.main ? accent.focus : accent.main,
  };
  const rgba = baseTheme.functions?.rgba;

  const borderColorValue = rgba ? rgba(accent.main, 0.4) : accent.main;
  const inputBorderColorValue = rgba ? rgba(accent.main, 0.5) : accent.main;

  return createTheme(baseTheme, {
    palette: {
      primary: accent,
      info: accent,
      gradients: {
        ...baseTheme.palette.gradients,
        [colorKey]: accentGradient,
        primary: accentGradient,
        info: accentGradient,
      },
      inputBorderColor: inputBorderColorValue,
    },
    borders: {
      ...baseTheme.borders,
      borderColor: borderColorValue,
    },
  });
}
